"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/audience.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Faudience.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.audienceToJSON = exports.audienceFromJSON = exports.Audience = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.auth.proto';
var Audience;
(function (Audience) {
    Audience["INVALID_AUDIENCE"] = "INVALID_AUDIENCE";
    /**
     * USER - Access for tokens issued via normal user authentication.
     */
    Audience["USER"] = "USER";
    /**
     * TEST - Audience associated with test API calls.
     */
    Audience["TEST"] = "TEST";
    /**
     * OPTECH - Access to a partner to act on behalf of a user.
     */
    Audience["OPTECH"] = "OPTECH";
    Audience["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Audience || (exports.Audience = Audience = {}));
function audienceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_AUDIENCE':
            return Audience.INVALID_AUDIENCE;
        case 1:
        case 'USER':
            return Audience.USER;
        case 2:
        case 'TEST':
            return Audience.TEST;
        case 3:
        case 'OPTECH':
            return Audience.OPTECH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Audience.UNRECOGNIZED;
    }
}
exports.audienceFromJSON = audienceFromJSON;
function audienceToJSON(object) {
    switch (object) {
        case Audience.INVALID_AUDIENCE:
            return 'INVALID_AUDIENCE';
        case Audience.USER:
            return 'USER';
        case Audience.TEST:
            return 'TEST';
        case Audience.OPTECH:
            return 'OPTECH';
        case Audience.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.audienceToJSON = audienceToJSON;
//# sourceMappingURL=audience.js.map